export default "__VITE_ASSET__CyT$mi1Q__"